import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import PromptGenerator from "./components/PromptGenerator";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import ConfirmEmail from "./components/auth/ConfirmEmail";
import Dashboard from "./components/auth/NewDashboard";
import Feedback from "./components/auth/Feedback";
import Docs from "./components/docs/Docs";
import SavedPrompts from "./components/SavedPrompts";
import Admin from "./components/admin/Admin";
import TeamsPolicy from "./components/admin/TeamsPolicy";
import EnterprisePolicy from "./components/admin/EnterprisePolicy";
import AiPlayground from "./components/ai/AiPlayground";
import UserBilling from "./components/auth/UserBilling";
import UserUsage from "./components/auth/UserUsage";
import MfaSetup from "./components/auth/MfaSetup";
import MfaChallengePage from "./pages/MfaChallengePage";
import Pricing from "./components/auth/Pricing";
import TopUp from "./components/payments/TopUp";
import SubscriptionManager from "./components/payments/SubscriptionManager";
import BAIQLEditor from "./components/baiql/BAIQLEditor";
import BAIQLExecutionMonitor from "./pages/BAIQLExecutionMonitor";
import ScriptsLibrary from "./components/baiql/ScriptsLibrary";
import AccessLogs from "./components/admin/AccessLogs";

const AppRoutes = [
  {
    path: '/teams',
    requireAuth: true,
    element: <TeamsPolicy />
  },
  {
    path: '/scripts-library',
    requireAuth: true,
    element: <ScriptsLibrary />
  },
  {
    path: '/baiql',
    requireAuth: true,
    element: <BAIQLEditor />
  },
  {
    path: '/baiql/exec/:id',
    requireAuth: true,
    element: <BAIQLExecutionMonitor />
  },
  {
    path: '/enterprise',
    requireAuth: true,
    element: <EnterprisePolicy />
  },
  {
    index: true,
    element: <Home />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/top-up',
    requireAuth: true,
    element: <TopUp />
  },
  {
    path: '/subscriptions',
    requireAuth: true,
    element: <SubscriptionManager />
  },
  {
    path: '/ai',
    requireAuth: true,
    element: <AiPlayground />
  },
  {
    path: '/admin',
    requireAuth: true,
    element: <Admin />
  },
  {
    path: '/admin/access-logs',
    requireAuth: true,
    element: <AccessLogs />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/app-info',
    element: <Home />
  },
  {
    path: '/docs',
    element: <Docs />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    path: '/reset-password',
    element: <ResetPassword />
  },
  {
    path: '/confirm-email',
    element: <ConfirmEmail />
  },
  {
    path: '/prompt-generator',
    requireAuth: true,
    element: <PromptGenerator />
  },
  {
    path: '/dashboard',
    requireAuth: true,
    element: <Dashboard />
  },
  {
    path: '/settings/billing',
    requireAuth: true,
    element: <UserBilling />
  },
  {
    path: '/settings/usage',
    requireAuth: true,
    element: <UserUsage />
  },
  {
    path: '/settings/security',
    requireAuth: true,
    element: <MfaSetup />
  },
  {
    path: '/mfa-challenge',
    element: <MfaChallengePage />
  },
  {
    path: '/saved-prompts',
    requireAuth: true,
    element: <SavedPrompts />
  },
  // Hidden for now - will be used later for reporting
  {
    path: '/counter',
    requireAuth: true,
    element: <Counter />
  },
  {
    path: '/fetch-data',
    requireAuth: true,
    element: <FetchData />
  }
];

export default AppRoutes;
